import { render, staticRenderFns } from "./VueButton2.vue?vue&type=template&id=611c0f50&"
import script from "./VueButton2.vue?vue&type=script&lang=js&"
export * from "./VueButton2.vue?vue&type=script&lang=js&"
import style0 from "./VueButton2.vue?vue&type=style&index=0&id=611c0f50&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports